import { render, staticRenderFns } from "./newreport_stu.vue?vue&type=template&id=47ec7378&scoped=true&"
import script from "./newreport_stu.vue?vue&type=script&lang=js&"
export * from "./newreport_stu.vue?vue&type=script&lang=js&"
import style0 from "./newreport_stu.vue?vue&type=style&index=0&id=47ec7378&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec7378",
  null
  
)

export default component.exports